import { FormApi } from 'final-form';
import PropTypes from 'prop-types';
import { AnyObject, FormProps, FormRenderProps, Form as ReactFinalForm } from 'react-final-form';
import FormAutoBackup from './FormAutoBackup';
import { Backup } from './FormAutoBackup/types';
import FormAutoSave from './FormAutoSave';
import FormInterceptor from './FormInterceptor';

interface Props<T> extends FormProps<T> {
    autoSave?: boolean;
    autoComplete?: 'on' | 'off';
    toBackup?: (form: FormApi<T>, values: T) => Backup;
    intercept?: boolean;
    formClassName?: string;
    debounceTime?: number;
}

export const Form = <T extends AnyObject>({
    children,
    autoSave,
    toBackup,
    intercept,
    autoComplete,
    formClassName,
    debounceTime,
    ...otherProps
}: Props<T>) => (
    <ReactFinalForm {...otherProps}>
        {(formRenderProps: FormRenderProps<T>) => (
            <form
                onSubmit={formRenderProps.handleSubmit}
                autoComplete={autoComplete}
                noValidate
                className={formClassName}
            >
                {!!autoSave && (
                    <FormAutoSave
                        keepDirtyOnReinitialize={!!otherProps.keepDirtyOnReinitialize}
                        debounceTime={debounceTime}
                    />
                )}
                {!!toBackup && <FormAutoBackup<T> toBackup={toBackup} />}
                {!!intercept && <FormInterceptor keepDirtyOnReinitialize={!!otherProps.keepDirtyOnReinitialize} />}
                {typeof children === 'function' ? children(formRenderProps) : children}
            </form>
        )}
    </ReactFinalForm>
);

Form.propTypes = {
    initialValues: PropTypes.object,
    children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]).isRequired,
    validate: PropTypes.func,
    onSubmit: PropTypes.func.isRequired,
    subscription: PropTypes.object,
};
